import { TeleconsultaAcceso } from '../Teleconsulta/TeleconsultaAccesso';

export const Teleconsulta = () => {
  return <TeleconsultaAcceso />;
};
